import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../Shared/Redux/store';

const initialState = {
  editUserAccountData: null,
  showAddUserForm: false,
};

const UserAccountsSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setShowAddUserForm: state => {
      state.showAddUserForm = !state.showAddUserForm;
    },
    setEditUserAccountData: (state, action: PayloadAction<any>) => {
      state.editUserAccountData = action.payload;
    },
  },
});

export const selectIsShowAddUserFormOpen = (state: RootState) =>
  state.user.showAddUserForm;

export const selectEditUserAccountData = (state: RootState) =>
  state.user.editUserAccountData;
export const selectEditStudentData = (state: RootState) =>
  state.student.editStudentData;

export const { setShowAddUserForm, setEditUserAccountData } =
  UserAccountsSlice.actions;

export default UserAccountsSlice.reducer;
